import React from 'react';
import { SvgProps } from 'apps/sigma2-ui/src/components/svg/types';
import { toSvgColor } from 'apps/sigma2-ui/src/components/svg/types';

export const IconSaveGroup: React.FC<SvgProps> = (props) => {
  const fillColor = toSvgColor('currentColor', props);

  return (
    <g fill="none" {...(props.group ?? {})}>
      <path
        d="M22 0H5.91C5.38042 0.00223279 4.87335 0.214412 4.5 0.59L0.59 4.5C0.214412 4.87335 0.00223279 5.38042 0 5.91L0 22C0 22.5304 0.210714 23.0391 0.585786 23.4142C0.960859 23.7893 1.46957 24 2 24H22C22.5304 24 23.0391 23.7893 23.4142 23.4142C23.7893 23.0391 24 22.5304 24 22V2C24 1.46957 23.7893 0.960859 23.4142 0.585786C23.0391 0.210714 22.5304 0 22 0ZM18.5 2C18.6326 2 18.7598 2.05268 18.8536 2.14645C18.9473 2.24021 19 2.36739 19 2.5V6.5C19 6.89782 18.842 7.27936 18.5607 7.56066C18.2794 7.84196 17.8978 8 17.5 8H7.5C7.10218 8 6.72064 7.84196 6.43934 7.56066C6.15804 7.27936 6 6.89782 6 6.5V2.5C6 2.36739 6.05268 2.24021 6.14645 2.14645C6.24021 2.05268 6.36739 2 6.5 2H18.5ZM5 22C4.86739 22 4.74021 21.9473 4.64645 21.8536C4.55268 21.7598 4.5 21.6326 4.5 21.5V13.5C4.5 13.1022 4.65804 12.7206 4.93934 12.4393C5.22064 12.158 5.60218 12 6 12H19C19.3978 12 19.7794 12.158 20.0607 12.4393C20.342 12.7206 20.5 13.1022 20.5 13.5V21.5C20.5 21.6326 20.4473 21.7598 20.3536 21.8536C20.2598 21.9473 20.1326 22 20 22H5Z"
        fill={fillColor}
      />
      <path
        d="M15 4.25V5.75C15 5.94891 15.079 6.13968 15.2197 6.28033C15.3603 6.42098 15.5511 6.5 15.75 6.5C15.9489 6.5 16.1397 6.42098 16.2803 6.28033C16.421 6.13968 16.5 5.94891 16.5 5.75V4.25C16.5 4.05109 16.421 3.86032 16.2803 3.71967C16.1397 3.57902 15.9489 3.5 15.75 3.5C15.5511 3.5 15.3603 3.57902 15.2197 3.71967C15.079 3.86032 15 4.05109 15 4.25Z"
        fill={fillColor}
      />
      <path
        d="M7 16.25H13.5C13.6989 16.25 13.8897 16.171 14.0303 16.0303C14.171 15.8897 14.25 15.6989 14.25 15.5C14.25 15.3011 14.171 15.1103 14.0303 14.9697C13.8897 14.829 13.6989 14.75 13.5 14.75H7C6.80109 14.75 6.61032 14.829 6.46967 14.9697C6.32902 15.1103 6.25 15.3011 6.25 15.5C6.25 15.6989 6.32902 15.8897 6.46967 16.0303C6.61032 16.171 6.80109 16.25 7 16.25Z"
        fill={fillColor}
      />
      <path
        d="M7 20.25H18C18.1989 20.25 18.3897 20.171 18.5303 20.0303C18.671 19.8897 18.75 19.6989 18.75 19.5C18.75 19.3011 18.671 19.1103 18.5303 18.9697C18.3897 18.829 18.1989 18.75 18 18.75H7C6.80109 18.75 6.61032 18.829 6.46967 18.9697C6.32902 19.1103 6.25 19.3011 6.25 19.5C6.25 19.6989 6.32902 19.8897 6.46967 20.0303C6.61032 20.171 6.80109 20.25 7 20.25Z"
        fill={fillColor}
      />
    </g>
  );
};

export const IconSaveSvg: React.FC<SvgProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      {...(props.svg ?? {})}
    >
      <IconSaveGroup {...props} />
    </svg>
  );
};
